// import React from "react";
// import { Toaster } from "react-hot-toast";

// interface GroupData {
//   groupId: number;

//   groupName: string;
//   groupPurpose: string;
//   isActive: boolean;
//   tenantId: number;
// }

// interface ViewGroupsCardProps {
//   groupsData: GroupData[];
//   onEditGroup: (group: GroupData) => void;
// }

// const ViewGroupsCard: React.FC<ViewGroupsCardProps> = ({
//   groupsData,
//   onEditGroup,
// }) => {
//   // Handle edit icon click
//   const handleEditClick = (group: GroupData) => {
//     onEditGroup(group);
//   };

//   return (
//     <div className="card">
//       <div>
//         <Toaster position="top-center" reverseOrder={false} />
//       </div>
//       <div className="card-header carHeaderWithBtn">
//         <h5 className="card-title mb-0">View Lead Groups</h5>
//       </div>
//       <div className="card-body">
//         <table className="table table-hover my-0">
//           <thead>
//             <tr>
//               <th>SL No</th>
//               <th>Group Name</th>
//               <th>Group Purpose</th>
//               <th>Active</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {groupsData.length === 0 ? (
//               <tr>
//                 <td colSpan={5} className="text-center">
//                   No groups found
//                 </td>
//               </tr>
//             ) : (
//               groupsData.map((group, index) => (
//                 <tr key={group.groupId}>
//                   <th scope="row">{index + 1}</th>
//                   <td>{group.groupName}</td>
//                   <td>{group.groupPurpose}</td>
//                   <td>
//                     <input
//                       className="form-check-input"
//                       type="checkbox"
//                       checked={
//                         typeof group.isActive === "boolean"
//                           ? group.isActive
//                           : group.isActive === "true"
//                       }
//                       disabled
//                       readOnly
//                     />
//                   </td>
//                   <td>
//                     <i
//                       className="bi bi-pencil-square colorgreen"
//                       style={{ cursor: "pointer" }}
//                       onClick={() => handleEditClick(group)}
//                     ></i>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default ViewGroupsCard;

import React, { useState } from "react";
import { Toaster } from "react-hot-toast";
import DataTable from "react-data-table-component";

interface GroupData {
  groupId: number;
  groupName: string;
  groupPurpose: string;
  isActive: boolean;
  tenantId: number;
}

interface ViewGroupsCardProps {
  groupsData: GroupData[];
  onEditGroup: (group: GroupData) => void;
  onAddClick: () => void;
  showAddButton: boolean;
}

const ViewGroupsCard: React.FC<ViewGroupsCardProps> = ({
  groupsData,
  onEditGroup,
  onAddClick,
  showAddButton,
}) => {
  const [toggleCleared, setToggleCleared] = useState(false);

  const handleRowSelected = (state: any) => {
    console.log("Selected rows:", state.selectedRows);
  };

  const columns = [
    {
      name: "Group Name",
      selector: (row: GroupData) => row.groupName,
      sortable: true,
      cell: (row: GroupData) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: "rgb(167 133 144)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "10px",
              fontWeight: "bold",
            }}
          >
            {row.groupName.charAt(0).toUpperCase()}
          </div>
          <span style={{ fontWeight: "500", color: "#33475b" }}>
            {row.groupName}
          </span>
        </div>
      ),
      width: "300px",
    },
    {
      name: "Group Purpose",
      selector: (row: GroupData) => row.groupPurpose,
      sortable: true,
      width: "400px",
    },
    {
      name: "Status",
      selector: (row: GroupData) => row.isActive,
      sortable: true,
      cell: (row: GroupData) => {
        const isActive =
          typeof row.isActive === "boolean"
            ? row.isActive
            : row.isActive === "true";
        return (
          <span className={isActive ? "active-status" : "inactive-status"}>
            {isActive ? "ACTIVE" : "INACTIVE"}
          </span>
        );
      },
      width: "250px",
    },
    {
      name: "",
      cell: (row: GroupData) => (
        <div className="action-cell">
          <button
            className="action-button edit-button"
            title="Edit Lead Group"
            onClick={() => onEditGroup(row)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button className="action-button more-button" title="More Actions">
            <i className="bi bi-three-dots"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "60px",
      className: "sticky-action-column",
    },
  ];

  return (
    <div className="card">
      <div>
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="card-header carHeaderWithBtn d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Lead Groups List</h5>
        {showAddButton && (
          <button
            type="button"
            className="demo-btn btn btn-outline-primary btn-sm"
            onClick={onAddClick}
          >
            <i className="fas fa-plus me-1"></i>+ Add Lead Group
          </button>
        )}
      </div>
      <div className="card-body p-0">
        <DataTable
          columns={columns}
          data={groupsData}
          pagination
          paginationPerPage={10}
          highlightOnHover
          striped
          responsive
          noDataComponent={
            <div className="text-center py-4">
              <p className="text-muted mb-0">No groups found.</p>
            </div>
          }
          selectableRows
          selectableRowsComponentProps={{
            className: "custom-checkbox",
          }}
          onSelectedRowsChange={handleRowSelected}
          clearSelectedRows={toggleCleared}
          fixedHeader
          fixedHeaderScrollHeight="400px"
        />
      </div>
    </div>
  );
};

export default ViewGroupsCard;
